module.exports = __webpack_public_path__ + "static/media/Screenshot_6.b8af7ed3.png";